module.exports = __webpack_public_path__ + "static/media/nowayround-regular-webfont.81a4ae79.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/nowayround-regular-webfont.eot
// module id = 250
// module chunks = 0